export default __webpack_public_path__ + "static/media/O-075.0bcf916f.png";